import { isIntent } from '../intent';
import { lazyStyleIntent } from '../style';
export function normalizeIntents(input, // TODO(koop): Uncomment these lines to add function handling;
//   add corresponding type definitions
// | ((props: Props) => View.Intent<Props>[])
intents = []) {
    if (isIntent(input)) {
        intents.push(input);
        return intents;
    } else if (Array.isArray(input)) {
        intents.push(...input);
        return intents;
    }
    // If we wanted to support functions:
    // } else if (typeof input === 'function') {
    //   intents.push(dynamic(input as (props: Props) => View.Intent<Props>[]));
    // }
    return null;
}
export function normalizeStyleIntents(value, intents = []) {
    if (isIntent(value)) {
        intents.push(value);
    } else if (Array.isArray(value)) {
        intents.push(...value);
    } else {
        intents.push(isIntent(value) ? value : lazyStyleIntent(value));
    }
    return intents;
}

//# sourceMappingURL=normalizeIntents.js.map